import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import ImportTours from './components/Admin/ImportTours';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import AdminContacts from './components/Admin/AdminContacts';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div id="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tours/import" element={<ImportTours />} />
            <Route path="/import" element={<ImportTours />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;